import { CultureInfo } from '../culture-info.model';
import { CultureInfoEn } from './en';

/**
 * @ignore
 */
export const CultureInfoEnRW: CultureInfo = {
  name: 'en-RW',
  displayName: 'English (Rwanda)',
  iso3LanguageCode: 'eng',
  iso2LanguageCode: 'en',
  ietfLanguageTag: 'en-RW',
  parent: CultureInfoEn
};
